import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';

import type { ImageSectionItem } from '../types';
import Item from './Item';
import LinkSectionListItemImage from './LinkSectionListItemImage';
import { ListItem } from './ListItem';

interface ImageLinkSectionListItemProps {
  index: number;
  item: ImageSectionItem;
  isInline?: boolean;
}

const UnstyledStyledListItem = styled(ListItem)``;

const StyledListItem = (props: ComponentProps<typeof UnstyledStyledListItem>) => (
  <UnstyledStyledListItem pr="sp_16" py="sp_8" width="auto" {...props} />
);

const ImageLinkSectionListItem = ({ index, item, isInline }: ImageLinkSectionListItemProps) => {
  if (!item.image) {
    return null;
  }

  return (
    <StyledListItem
      data-testid={`link-section-list-item-${index}`}
      {...(isInline ? { py: ['sp_8', 'sp_0'] } : {})}
    >
      <Item item={item}>
        <LinkSectionListItemImage
          width={item.image.width}
          height={item.image.height}
          src={item.image.src}
          alt={item.name ?? ''}
        />
      </Item>
    </StyledListItem>
  );
};

export default ImageLinkSectionListItem;
